var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15403",
    "data-name": "Group 15403",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.826,
    height: 103.481,
    viewBox: "0 0 72.826 103.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#944200",
    stopOpacity: 0.471
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#a04c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#b65e00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#bf6500",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#d17618",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffa054",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ff832a",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ffaa3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d97b1a",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#bf5a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b05400",
    stopOpacity: 0.541
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9b4c00",
    stopOpacity: 0.431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#944a00",
    stopOpacity: 0.388
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#944a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9b4e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#b05b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bf6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff832a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffa054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d17618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#bf6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#b65e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#a04c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#944200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M68.222,252.781v49.6l23.555-9.326,22.83,9.326v-49.6Z",
    transform: "translate(-68.222 -252.781)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M84.579,300.369l-2.017.8V252.781h2.017Z",
    transform: "translate(-82.562 -252.781)",
    fill: "#ff8f3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M262.822,300.369l2.017.8V252.781h-2.017Z",
    transform: "translate(-262.822 -252.781)",
    fill: "#ff8f3b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M36.767,2.15,34.489.451,32.436,2.419l-2.473-1.4L28.175,3.229,25.542,2.15,24.048,4.567,21.3,3.83,20.123,6.418,17.307,6.03l-.846,2.716-2.842-.032-.5,2.8-2.827.322-.145,2.839-2.763.674L7.6,18.185,4.937,19.2,5.5,21.985,2.993,23.326l.91,2.692L1.584,27.664l1.243,2.558L.733,32.147l1.554,2.381L.452,36.7l1.835,2.17L.733,41.249l2.093,1.925L1.584,45.732,3.9,47.376l-.91,2.694L5.5,51.409,4.937,54.2,7.6,55.21l-.211,2.835,2.763.674.147,2.839,2.824.324.5,2.8,2.842-.032.844,2.716,2.818-.386L21.3,69.564l2.746-.738,1.494,2.419,2.63-1.079,1.791,2.211,2.473-1.4,2.053,1.968,2.279-1.7,2.281,1.7L41.1,70.976l2.473,1.4,1.788-2.211,2.63,1.079,1.5-2.419,2.746.74,1.179-2.588,2.816.386.844-2.716,2.844.032.5-2.8,2.827-.324.145-2.839,2.763-.674-.209-2.835L68.6,54.2l-.565-2.788,2.509-1.339-.91-2.692,2.319-1.646L70.71,43.174,72.8,41.249l-1.554-2.381,1.835-2.17-1.835-2.17L72.8,32.147,70.71,30.222l1.243-2.558-2.319-1.646.91-2.692-2.509-1.341L68.6,19.2l-2.658-1.015.209-2.835-2.76-.671-.147-2.842-2.824-.322-.5-2.8-2.842.03-.846-2.714-2.816.386L52.235,3.83l-2.746.738-1.5-2.417-2.63,1.079L43.574,1.018,41.1,2.419,39.048.451Z",
    transform: "translate(-0.452 -0.451)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#944200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#a04c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#b65e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#bf6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#d17618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffa054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ff832a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ffaa3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d97b1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#bf5a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b05400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9b4c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#944a00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 72.826,
    height: 103.481,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M24.88,52.78A28.23,28.23,0,1,1,53.11,81.01,28.263,28.263,0,0,1,24.88,52.78m-3.658,0A31.889,31.889,0,1,0,53.11,20.892a31.888,31.888,0,0,0-31.888,31.89",
    transform: "translate(-21.222 -20.892)",
    fill: "url(#linear-gradient-2)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(14.543 53.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 46.385,
    height: 49.596,
    transform: "translate(0)",
    fill: "#d8d8d8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(17.6 53.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 35.641,
    height: 35.641,
    transform: "translate(-24.194 24.194) rotate(-45)",
    fill: "#ff8f3b"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(56.025 53.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 35.641,
    height: 35.641,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, -24.194, 24.193)",
    fill: "#ff8f3b"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(0.096 0.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 96.464,
    height: 96.396,
    transform: "translate(-27.765 12.947) rotate(-24.999)",
    fill: "url(#linear-gradient-3)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M73.085,36.7l-1.835,2.17L72.8,41.249,70.71,43.174l1.243,2.558-2.319,1.646.91,2.692-2.509,1.339L68.6,54.2,65.941,55.21l.209,2.835-2.763.674-.145,2.839-2.827.324-.5,2.8-2.844-.032-.844,2.716-2.816-.386-1.179,2.588-2.746-.74-1.5,2.419-2.63-1.079-1.788,2.211-2.473-1.4-2.053,1.968-2.281-1.7-2.279,1.7-2.053-1.968-2.473,1.4-1.791-2.211-2.63,1.079-1.494-2.419-2.746.738-1.179-2.586-2.818.386-.844-2.716-2.842.032-.5-2.8-2.824-.324-.147-2.839-2.763-.674L7.6,55.21,4.937,54.2,5.5,51.409,2.993,50.07l.91-2.694L1.584,45.732l1.243-2.558L.733,41.249l1.554-2.381L.452,36.7l1.835-2.17L.733,32.147l2.093-1.925L1.584,27.664,3.9,26.018l-.91-2.692L5.5,21.985,4.937,19.2,7.6,18.185l-.209-2.835,2.763-.674.145-2.839,2.827-.322.5-2.8,2.842.032.846-2.716,2.816.388L21.3,3.83l2.746.738L25.542,2.15l2.633,1.079,1.788-2.211,2.473,1.4L34.488.451l2.279,1.7,2.281-1.7L41.1,2.419l2.473-1.4,1.788,2.211,2.63-1.079,1.5,2.417,2.746-.738,1.179,2.588,2.816-.386.846,2.714,2.842-.03.5,2.8,2.824.322.147,2.842,2.761.671-.209,2.835L68.6,19.2l-.565,2.786,2.509,1.341-.91,2.692,2.319,1.646L70.71,30.222,72.8,32.147l-1.554,2.381Z",
    transform: "translate(-0.355 -0.355)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.69
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    transform: "translate(4.524 4.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 90.195,
    height: 90.195,
    transform: "translate(-31.889 31.89) rotate(-45.001)",
    fill: "url(#linear-gradient-2)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M53.11,20.892A31.889,31.889,0,1,0,85,52.782,31.889,31.889,0,0,0,53.11,20.892Zm0,60.118A28.23,28.23,0,1,1,81.34,52.78,28.262,28.262,0,0,1,53.11,81.01Z",
    transform: "translate(-16.698 -16.438)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 27.814,
    cy: 27.814,
    rx: 27.814,
    ry: 27.814,
    transform: "translate(8.459 8.386)",
    fill: "none",
    stroke: "#251e1c",
    strokeWidth: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M93.167,63.994A28.852,28.852,0,1,1,64.314,35.142,28.851,28.851,0,0,1,93.167,63.994Z",
    transform: "translate(-27.903 -27.651)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.86
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.4573a076a52c8706c80cc5a123acfde1.svg";
export { ForwardRef as ReactComponent };